import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ContinueArrowIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 42 32"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      stroke={svgProps.stroke ?? "none"}
      fill={color ?? svgProps.fill ?? "currentColor"}
    >
      <path d="M41.6 15.443 26.296.139C26.018 0 25.739 0 25.461 0a.765.765 0 0 0-.417.696v8.348H.696c-.417 0-.696.278-.696.696v12.522c0 .417.278.696.696.696h24.348v8.348c0 .278.139.557.417.696h.278c.139 0 .417-.139.557-.139L41.6 16.559c.139-.278.139-.835 0-1.113z" />
    </SVG>
  );
};
